var map = {
	"./amazon-clone.png": 892,
	"./atom.png": 375,
	"./background.jpg": 314,
	"./banner.png": 577,
	"./food.jpg": 436,
	"./header-background.jpg": 66,
	"./java-script.png": 963,
	"./java.png": 235,
	"./laptopimage.jpg": 811,
	"./man.png": 207,
	"./me.jpg": 460,
	"./mobile.jpg": 290,
	"./music.jpg": 87,
	"./node-js.png": 717,
	"./portfolio.jpg": 49,
	"./recipe.jpg": 275,
	"./woman.png": 668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 638;